/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdButtonToggleGroup, MdButtonToggleGroupMultiple, MdButtonToggle} from './button-toggle';
import {UNIQUE_SELECTION_DISPATCHER_PROVIDER, MdCommonModule} from '@angular/material/core';
import {A11yModule} from '@angular/cdk/a11y';
export class MdButtonToggleModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdCommonModule, A11yModule],
  exports: [
    MdButtonToggleGroup,
    MdButtonToggleGroupMultiple,
    MdButtonToggle,
    MdCommonModule,
  ],
  declarations: [MdButtonToggleGroup, MdButtonToggleGroupMultiple, MdButtonToggle],
  providers: [UNIQUE_SELECTION_DISPATCHER_PROVIDER]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdButtonToggleModule_tsickle_Closure_declarations() {
/** @type {?} */
MdButtonToggleModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdButtonToggleModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
